import { render } from "./pictcarousel.vue?vue&type=template&id=2e4b5e5a&scoped=true"
import script from "./pictcarousel.vue?vue&type=script&lang=js"
export * from "./pictcarousel.vue?vue&type=script&lang=js"

import "./pictcarousel.vue?vue&type=style&index=0&id=2e4b5e5a&lang=scss&scoped=true"
import "./pictcarousel.vue?vue&type=style&index=1&id=2e4b5e5a&lang=scss"
script.render = render
script.__scopeId = "data-v-2e4b5e5a"

export default script